var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('general-network',{attrs:{"network":"linkedin"}},[_c('v-icon',{staticClass:"app-bar-social-icon",attrs:{"size":"18"}},[_vm._v("fa fa-linkedin")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }